import { render } from "./Natal25.vue?vue&type=template&id=569b3806"
import script from "./Natal25.vue?vue&type=script&lang=js"
export * from "./Natal25.vue?vue&type=script&lang=js"

import "./Natal25.vue?vue&type=style&index=0&id=569b3806&lang=scss"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__